import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemListEntity } from './item-list.entity';
import { ItemEntity } from './item.entity';

/**
 * Membership row: one item on one item list (PD-15839). Soft-deleted rows
 * are how a member is removed, so every membership query filters on
 * `_deleted_date IS NULL`.
 */
@Index('idx_item_list_item_item', ['fkItemId'], {})
@Index('idx_item_list_item_deleted', ['deletedDate'], {})
@Index('idx_item_list_item_list', ['fkItemListId'], {})
@Index('idx_item_list_item_unique', ['fkItemListId', 'fkItemId'], {
	unique: true,
})
@Entity('item_list_item')
export class ItemListItemEntity extends BaseEntity {
	@Column('int', { name: 'fk_item_list__id', unsigned: true })
	public fkItemListId!: number;

	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@ManyToOne(() => ItemEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public item!: ItemEntity;

	@ManyToOne(() => ItemListEntity, (itemList) => itemList.itemListItems, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_item_list__id', referencedColumnName: 'id' }])
	public itemList!: ItemListEntity;
}
